<div class="adm-shell">
  <!-- ── Top navigation (desktop horizontal bar; on mobile only the brand logo remains — see admin-shell.mobile.scss) ── -->
  @if (auth.isAuthenticated$ | async) {
    <header class="adm-topnav" aria-label="Admin">
      <a routerLink="/auth/admin-dashboard" class="adm-topnav__brand">
        <img src="./assets/logo-horizontal-dark.svg" alt="AppliedBioX" class="adm-topnav__logo" />
      </a>

      <nav class="adm-topnav__nav" aria-label="Primary">
        @for (item of primaryNav; track item.path) {
          <a
            [routerLink]="item.path"
            class="adm-topnav__link"
            [class.adm-topnav__link--active]="isNavItemActive(item)"
            [attr.aria-current]="isNavItemActive(item) ? 'page' : null">
            {{ item.label }}
          </a>
        }

        <!-- Operations cluster — collapsed into a dropdown -->
        <div class="adm-topnav__dropdown">
          <button
            type="button"
            class="adm-topnav__link adm-topnav__trigger"
            [class.adm-topnav__link--active]="isOperationsActive()"
            (click)="toggleOperations($event)"
            [attr.aria-expanded]="operationsOpen()"
            aria-haspopup="true">
            Operations
            <i class="bx bx-chevron-down adm-topnav__caret" aria-hidden="true"></i>
          </button>
          @if (operationsOpen()) {
            <div class="adm-topnav__menu" role="menu">
              @for (item of operationsNav; track item.path) {
                <a
                  [routerLink]="item.path"
                  class="adm-topnav__menu-item"
                  [class.adm-topnav__menu-item--active]="isNavItemActive(item)"
                  role="menuitem">
                  <i class="bx {{ item.icon }}" aria-hidden="true"></i>
                  <span>{{ item.label }}</span>
                </a>
              }
            </div>
          }
        </div>
      </nav>

      <div class="adm-topnav__right">
        <abx-dark-mode-toggle class="adm-topnav__theme" />
        <a
          [routerLink]="settingsNav.path"
          class="adm-topnav__settings"
          [class.adm-topnav__settings--active]="isNavItemActive(settingsNav)"
          [attr.aria-current]="isNavItemActive(settingsNav) ? 'page' : null">
          <i class="bx bx-cog" aria-hidden="true"></i>
          <span>Settings</span>
        </a>
        <span class="adm-topnav__divider" aria-hidden="true"></span>
        <bodyanalytics-profile-menu [accountUrl]="profileAccountUrl" />
      </div>
    </header>
  }

  <!-- ── Page-header band (data-driven title; preserved from the old topbar) ──
       Hidden on routes whose leaf component renders its own `.adm-page__header`
       (see AdminShellComponent.hideHeaderBand) so the two headers don't stack. -->
  @if ((auth.isAuthenticated$ | async) && !hideHeaderBand()) {
    <div class="adm-pagehead">
      <div class="eyebrow adm-pagehead__subtitle">{{ pageSubtitle }}</div>
      <h1 class="adm-pagehead__title">{{ pageTitle }}</h1>
    </div>
  }

  <!-- ── Page content ── -->
  <div class="adm-content">
    <!-- #2950 review F1: the body wrapper carries the 32px content→footer gap
         (padding-block-end) and grows to fill short pages (flex: 1 0 auto),
         so the footer pins to the bottom without `margin-top: auto` and routed
         components never become flex items themselves. -->
    <div class="adm-content__body">
      <router-outlet />
    </div>
    <!-- #2246: the full marketing footer (nav columns, social, CTAs) belongs on
         public pages, not inside the signed-in admin shell — replaced with a
         slim internal footer. -->
    <footer class="adm-footer">
      <span>© {{ currentYear }} AppliedBioX</span>
      <a href="mailto:support@appliedbiox.com">Support</a>
    </footer>
  </div>
</div>
